import styled from 'styled-components';
import { COLOR_WHITE } from '@common/assets/styles/colors';

const LayoutSC = styled.div`
  z-index: 2147483641;
  background-color: ${COLOR_WHITE};
  position: fixed;
  box-shadow: 0 2px 6px 0 rgba(51, 61, 108, 0.25);
`;

export const LayoutOpenSC = styled(LayoutSC)`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: ${({ theme }) => (theme.responsive ? 'auto' : '375px')};

  height: 535px;

  right: ${({ theme }) => (theme.responsive ? '0' : '5px')};
  bottom: ${({ theme }) => (theme.responsive ? '0' : '5px')};

  border-radius: ${({ theme }) => (theme.responsive ? '0' : '16px')};

  h4 {
    line-height: 20px;
    font-weight: bold;
  }
`;

export const LayoutClosedSC = styled(LayoutSC)<{ isMobile: boolean }>`
  right: 5px;
  bottom: 5px;

  background-color: transparent;
  box-shadow: none;

  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    width: ${({ isMobile }) => (isMobile ? 83 : 190)}px;
  }
`;
